<template>
  <div class="sign-in-phone-update">
    <form class="sign-in-phone-update__form" @submit.prevent="signInDoPhoneUpdate">
      <DefTitle v-if="response.phone" :result="4">
        <span>
          {{ messages.isYourPhone }}
        </span>

        <!--                <div>-->
        <!--                    <DefButtonSecondary @click="isPhoneReadOnly = true">-->
        <!--                        {{ messages.yes }}-->
        <!--                    </DefButtonSecondary>-->

        <!--                    <DefButtonSecondary @click="isPhoneReadOnly = false">-->
        <!--                        {{ messages.no }}-->
        <!--                    </DefButtonSecondary>-->
        <!--                </div>-->
      </DefTitle>

      <!--            :readonly="isPhoneReadOnly"-->
      <!--            :class="{ 'sign-in-phone-update__not-allowed': isPhoneReadOnly}"-->
      <DefPhone
        :placeholder="messages.enterPhone"
        name="phone"
        type="text"
        :value="response.phone || ''"
        :required="true"
      />

      <DefButtonPrimary type="submit">
        {{ messages.btnGetCodeSms }}
      </DefButtonPrimary>
    </form>
    <div class="sign-in-phone-update__errors">
      <span v-for="error in personal.errors">{{ error }}</span>
    </div>
    <!--        <SignInBySocials />-->
    <!--        <hr class="sign-in-phone-update__line">-->
    <!--        <GoSignUp />-->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import SignInConfirmUpdatingPhone from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInConfirmUpdatingPhone.vue';
import SignInUserExist from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInUserExist.vue';
import DefPhone from '../../../Def/DefPhone/DefPhone';
import Recaptcha3 from '../../../../utils/Recaptcha3';

export default {
  name: 'SignInPhoneUpdate',
  components: {
    DefButtonPrimary,
    DefTitle,
    DefPhone,
  },
  props: ['result', 'messages', 'response'],
  data() {
    return {
      modal: useModal(),
      // isPhoneReadOnly: true,
    };
  },
  computed: {
    ...mapState({
      personal: ({ personal }) => personal.data,
    }),
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
    }),
    async signInDoPhoneUpdate(e) {
      const formData = new FormData(e.target);
      const token = await Recaptcha3.getSubmitToken();
      let phone = formData.get('phone');
      phone = phone?.replace(/[+| |(|)]/g, '');
      const requestParams = {
        'g-recaptcha-response': token,
        id: this.response.id,
        phone,
      };
      this.loaderStart();
      const response = await this.$store.dispatch('personal/signInDoPhoneUpdate', {
        requestParams,
      });
      this.loaderStop();

      if (response.status && response.isCodeWasSend) {
        this.modal.show(
          SignInConfirmUpdatingPhone,
          {
            result: response,
            messages: this.messages,
          },
          {
            width: '360px',
          }
        );
        // this.$DefModal.show({
        //   name: 'SignInConfirmUpdatingPhone',
        //   width: '360px',
        //   props: { result: response, messages: this.messages },
        //   backgroundClose: () => '',
        //   isShowClose: false,
        // });
      } else {
        this.modal.show(
          SignInUserExist,
          { message: response.text, phone },
          {
            width: '440px',
          }
        );
        // this.$DefModal.show({
        //   name: 'SignInUserExist',
        //   width: '440px',
        //   props: { message: response.text, phone },
        //   isShowClose: false,
        //   backgroundClose: () => '',
        // });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-in-phone-update {
  &__form {
  }
  &__line {
    margin: 32px 0;
    border: unset;
    border-bottom: 1px solid var(--border-grey);
  }
  :deep(.def-phone) {
    margin-bottom: 8px;
  }
  :deep(.def-button-secondary) {
    width: 50%;
  }
  :deep(.def-button-primary) {
    width: 100%;
  }
  /*:has(.sign-in-phone-update__not-allowed) {*/
  /*    cursor: not-allowed;*/
  /*}*/
  &__errors {
    color: red;
    margin-top: 10px;
  }
}
</style>
